import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from 'react-router-dom';
import AppTopBar from './common/app-top-bar';
import '../css/property-list.css';
import { Avatar, Container, Paper, Button, Divider, 
  List, ListItem, ListItemAvatar, ListItemButton, ListItemIcon, ListItemText, Select, Typography, MenuItem, FormControl, InputLabel, TextField, Grid 
} from '@mui/material';
import Box from '@mui/material/Box';
import Snackbar from '@mui/material/Snackbar';
import { AppHelper } from '../AppHelper';
import LoadingButton from '@mui/lab/LoadingButton';

export default function PageFeedback() {
  const oUser = AppHelper.userCacheGet();
  const [msgBox, setMsgBox] = React.useState({
    open: false, vertical: 'top', horizontal:'center', msg: ''
  });
  const [txtNameOK, setTxtNameOK] = useState(true);
  const [isSubmitting, setIsSubmitting] = React.useState(false);
  const feedbackTypes = [
    {code:'-', name: '-- Select --'},
    {code: 'BUG', name:'BUG REPORT'},
    {code: 'FEATURE', name:'FEATURE REQUEST'},
    {code: 'GENERAL', name:'GENERAL FEEDBACK'},
  ];
  const [feedback, setFeedback] = useState('');
  const [feedbackType, setFeedbackType] = useState('-');
  const [feedbackTypeOK, setFeedbackTypeOK] = useState(true);

  const onSelectDdl = (event) => {
    var _newValue = event.target.value;
    setFeedbackType(_newValue);
    if(_newValue !== '-'){
      setFeedbackTypeOK(true);
    }
    else setFeedbackTypeOK(false);
  };
  const onUpdate = async()=>{
    if(!isDataOK()) return;
    setIsSubmitting(true);
    var _res = await AppHelper.api('api/email', 'POST', { email:oUser.email, name:oUser.displayName, feedbackType, feedbackMsg:feedback });
    setIsSubmitting(false);
    if(_res.status != 1){
      setMsgBox({...msgBox, open: true, msg: 'ERROR: Submission failed!'});
      return;
    }
    setMsgBox({...msgBox, open: true, msg: 'SUCCESS: Feedback submitted!'});
    setTimeout(() => {
      goBack();
    }, 1000*1);
  }
  const goBack = ()=>{
    window.history.back();
  };
  const isDataOK = ()=>{
    var _validateOK = true;
    if((!feedback || feedback.length<1)){
      _validateOK =  false;
      setTxtNameOK(false);
      setMsgBox({...msgBox, open: true, msg: 'Please enter the feedback message!'});
    }
    else setTxtNameOK(true);
    if(!feedbackType || feedbackType.length<1 || feedbackType === '-'){
      setFeedbackTypeOK(false);
      _validateOK = false;
    }
    else setFeedbackTypeOK(true);

    return _validateOK;
  };
  const onChangeFeedback = (arg)=>{
    setFeedback(arg.target.value);
  };

  return (
    <>
      <AppTopBar />
      <Container component="main" maxWidth="sm" sx={{ mb: 4 }}>
        <Paper sx={{ my: { xs: 3, md: 5 }, p: { xs: 2, md: 3 }, minHeight:{md:'75vh', xs:'75vh'} }} elevation={3}>
          <Box p={2} pl={2} pr={2} alignItems="flex-start">
            <ListItem disablePadding>
              <ListItemText
                primary={
                  <React.Fragment>
                    <span style={{fontWeight:'bold', fontSize:'1.3rem'}}>
                    FEEDBACK
                    </span>
                  </React.Fragment>
                }
                secondary={
                  <React.Fragment>
                    <Typography
                      sx={{ display: 'inline' }}
                      component="span"
                      variant="body2"
                      color="text.primary"
                    >
                    </Typography>
                    {" — " + oUser.displayName}
                  </React.Fragment>
                }
              />
              <ListItemAvatar sx={{minWidth:70, display:'flex', justifyContent:'center'}}>
                <Avatar src={oUser.picture} referrerPolicy="no-referrer" />
              </ListItemAvatar>
            </ListItem>
            <Grid>
              <Grid item xs={12} sm={6}>
                <Box m={.5} pt={1.5}>
                  <FormControl fullWidth error={!feedbackTypeOK}>
                    <InputLabel id='lblDdlCountry'>FEEDBACK TYPE</InputLabel>
                    <Select labelId='lblDdlCountry' label="FEEDBACK TYPE"
                      value={feedbackType}
                      onChange={onSelectDdl}
                    >
                      {feedbackTypes.map((item) => (
                        <MenuItem key={item.code} value={item.code}>
                          {item.name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Box>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Box m={.5} pt={1}>
                  <textarea onChange={onChangeFeedback} rows={7} style={{width:'100%', textAlign:'left', border: '1px solid #d3d3d3'}} ></textarea>
                </Box>
              </Grid>
              <Grid container pt={.5}>
                <Grid item xs={6}>
                  <Button onClick={goBack} color="secondary">BACK</Button>
                </Grid>
                <Grid item xs={6}>
                  <Box display="flex" justifyContent="flex-end">
                    <LoadingButton
                        onClick={onUpdate}
                        loading={isSubmitting}
                        variant="contained"
                      >
                        <span>SUBMIT</span>
                    </LoadingButton>
                  </Box>
                </Grid>
              </Grid>
            </Grid>
          </Box>
        </Paper>
      </Container>
      <Snackbar
        open={msgBox.open}
        autoHideDuration={6000}
        message={msgBox.msg}
        anchorOrigin={{ vertical:msgBox.vertical, horizontal:msgBox.horizontal }}
        onClose={() => setMsgBox({...msgBox, open: false})}
      />
    </>
  );
}
